// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"195":"page-data","495":"page-intro","610":"page-literature","689":"page-design","764":"page-material"}[chunkId] + "." + {"195":"9053a46c","495":"751f51de","610":"1826fcd1","689":"993c8acd","764":"7fd8e1e4"}[chunkId] + ".js";
};